import React from "react";
import TreeMethodImage from "./images/tree-view-selection-method.jpg";
import BatchMethodImage from "./images/batch-onboarding-method.jpg";
import { setQueryString } from "helpers/QueryString";

const METHOD_TYPE = {
  TREE: {
    key: "TREE",
    title: "Tree View Selection",
    image: TreeMethodImage,
    description:
      "I would like to view the full scope of my inventory in Tree View.",
  },
  BATCH: {
    key: "BATCH",
    title: "Batch Onboarding",
    image: BatchMethodImage,
    description:
      "Easier to onboard if you have a list of GAM ad unit ids ready.",
  },
};

class OnboardAdUnits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      adUnits: [],
    };

    this.handleMethodSelect = this.handleMethodSelect.bind(this);
  }

  handleMethodSelect(method) {
    const { yieldSetId, networkId } = this.props;

    if (yieldSetId && networkId) {
      const queryString = setQueryString(
        this.props,
        { yieldSetId, networkId },
        true
      );

      if (method === METHOD_TYPE.TREE) {
        window.open(
          `${window.location.origin}/#/ops-mgmt/account/onboard-ad-units-tree-view?${queryString}`
        );
      } else if (method === METHOD_TYPE.BATCH) {
        window.open(
          `${window.location.origin}/#/ops-mgmt/account/onboard-ad-units?${queryString}`
        );
      }
    }
  }

  render() {
    return (
      <div className="mx-auto w-3/4 pt-2">
        <div className="mb-1 text-lg font-semibold text-gray-800">
          Choose how you would like to onboard:
        </div>
        <div className="flex gap-4">
          <div className="w-1/2">
            <MethodCard
              method={METHOD_TYPE.TREE}
              handleMethodSelect={this.handleMethodSelect}
            ></MethodCard>
          </div>
          <div className="w-1/2">
            <MethodCard
              method={METHOD_TYPE.BATCH}
              handleMethodSelect={this.handleMethodSelect}
            ></MethodCard>
          </div>
        </div>
      </div>
    );
  }
}

class MethodCard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isHovered: false,
    };
  }

  render() {
    const { method } = this.props;
    const { isHovered } = this.state;
    return (
      <div
        className="cursor-pointer text-gray-700 hover:text-blue-700"
        onMouseOver={() => {
          this.setState({ isHovered: true });
        }}
        onMouseOut={() => {
          this.setState({ isHovered: false });
        }}
        onClick={() => {
          this.props.handleMethodSelect(method);
        }}
      >
        <h5
          style={{
            textTransform: "uppercase",
            letterSpacing: "0.025em",
            fontSize: "1.025rem",
            fontWeight: "600",
          }}
        >
          {method.title}
        </h5>
        <div
          className={`border rounded h-64 bg-white px-4 py-2 ${
            isHovered ? "border-blue-400 shadow-md" : ""
          }`}
        >
          <p className="text-gray-500">{method.description}</p>

          <div className="justify-content-center flex">
            <img src={method.image} />
          </div>
        </div>
      </div>
    );
  }
}

export default OnboardAdUnits;
